import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

// Axios interceptor to attach JWT automatically
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Name, Password must be exactly as UserLogin in backend !!!!
export const loginUser = async (Name, Password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, { Name, Password });
    if (response.data.access_token) {
      localStorage.setItem("token", response.data.access_token);
    }
    return response.data;
  } catch (err) {
    const message =
      err.response?.data?.detail ||
      JSON.stringify(err.response?.data) ||
      "Login failed";
    const error = new Error(message);
    throw error;
  }
};

export const registerUser = async (email, password, username, locale, country, cupCode) => {
  const response = await axios.post(`${API_URL}/user/`, {
    Email: email || null, Password: password, Name: username, Locale: locale, Country: country,
    CupCode: cupCode || null,
  });
  return response.data;
};

// Authenticated API call example
export const getProfile = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/profile`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

export const logoutUser = () => {
  localStorage.removeItem("token");
  window.location.href = "/login"; // redirect to login page
};